import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@bingads-webui-react/primitive';

export const PiOnHoldDialog = ({
  i18n,
  isShow,
  declinedDate,
  onDialogClose,
  onSubmit,
  onPayBalance,
  renderFallbackPayBalanceButton: FallbackPayBalanceButton,
  isAccountCreate,
}) => (
  <Modal id="pi-onhold-dialog" show={isShow} backdrop="static" className="pi-action-dialog" onHide={onDialogClose} bsSize="lg">
    <Modal.Header closeButton>
      <Modal.Title>{i18n.getString(isAccountCreate ? _TL_('Your new account will be on hold') : _TL_('Your account may be placed on hold'))}</Modal.Title>
    </Modal.Header>
    <Modal.Body className="onhold-pi-content">
      {isAccountCreate ?
        <React.Fragment>
          <p>{i18n.getString(_TL_('Your new account will be on hold and won\'t display ads because the primary card was declined on {{declinedDate}}.', { comment: '{{declinedDate}} will be date.' }), { declinedDate })}</p>
          <p>{i18n.getString(_TL_('To remove the hold, you can:'))}</p>
        </React.Fragment> :
        <React.Fragment>
          <p>{i18n.getString(_TL_('Your account may be placed on hold and may not display ads because the primary card was declined on {{declinedDate}}.', { comment: '{{declinedDate}} will be date.' }), { declinedDate })}</p>
          <p>{i18n.getString(_TL_('If you\'ve already taken care of this issue, feel free to use this card without any worries. If you haven\'t, we encourage you to:'))}</p>
        </React.Fragment>}
      <ul className="you-can-choose">
        <li type="disc">
          {i18n.getString(_TL_('Pay the outstanding balance'))}
        </li>
        <li type="disc">
          {i18n.getString(_TL_('Use a new or a backup payment method'))}
        </li>
      </ul>
      <p>{i18n.getString(_TL_('You can still use this card, but any account tied to it is subject to a credit hold until payment issues are resolved.'))}</p>
    </Modal.Body>
    <Modal.Footer>
      {FallbackPayBalanceButton ?
        <FallbackPayBalanceButton text={i18n.getString(_TL_('Pay balance'))} /> :
        <Button className="pay-balance-button" btnStyle="primary" onClick={onPayBalance}>
          {i18n.getString(_TL_('Pay balance'))}
        </Button>}
      <Button className="another-card-button" btnStyle="primary" onClick={onDialogClose} >{i18n.getString(_TL_('Associate another card'))}</Button>
      <Button className="submit-button" onClick={onSubmit}>{i18n.getString(_TL_('Use this card'))}</Button>
    </Modal.Footer>
  </Modal>
);

PiOnHoldDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isShow: PropTypes.bool.isRequired,
  declinedDate: PropTypes.string.isRequired,
  onDialogClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onPayBalance: PropTypes.func,
  renderFallbackPayBalanceButton: PropTypes.elementType,
  isAccountCreate: PropTypes.bool,
};
PiOnHoldDialog.defaultProps = {
  onPayBalance: null,
  renderFallbackPayBalanceButton: null,
  isAccountCreate: false,
};

